import {IconType} from "react-icons";
import {components, ControlProps, GroupBase} from "react-select";

import {Icon} from "@/components/icon/Icon.tsx";

export const Control = <Option, IsMulti extends boolean = false, Group extends GroupBase<Option> = GroupBase<Option>>({
  children,
  leftIcon,
  ...props
}: ControlProps<Option, IsMulti, Group> & {leftIcon?: IconType}) => {
  return (
    <components.Control {...props}>
      {!!children && leftIcon && (
        <Icon icon={leftIcon} className={"pulse-color-gray-500"} style={{position: "absolute", left: 6}} />
      )}
      {children}
    </components.Control>
  );
};
